import { apiRequest } from './api';
import { Tag, ApiResponse } from '../types';

export interface TagCreateData {
  titulo: string;
  color: string;
  ativo?: boolean;
}

export interface TagUpdateData extends Partial<TagCreateData> { }

class TagService {
  private baseUrl = '/tags';

  // Obter todas as tags com paginação e busca
  async getAll(params: { page?: number; limit?: number; search?: string } = {}): Promise<ApiResponse<Tag[]>> {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);

    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return apiRequest.get<Tag[]>(`${this.baseUrl}${queryString}`);
  }

  // Obter tag por ID
  async getById(id: number): Promise<Tag> {
    const response = await apiRequest.get<Tag>(`${this.baseUrl}/${id}`);
    if (!response.data) throw new Error('Tag não encontrada');
    return response.data;
  }

  // Criar nova tag
  async create(data: TagCreateData): Promise<Tag> {
    const response = await apiRequest.post<Tag>(this.baseUrl, data);
    if (!response.data) throw new Error('Falha ao criar tag');
    return response.data;
  }

  // Atualizar tag
  async update(id: number, data: TagUpdateData): Promise<Tag> {
    const response = await apiRequest.put<Tag>(`${this.baseUrl}/${id}`, data);
    if (!response.data) throw new Error('Falha ao atualizar tag');
    return response.data;
  }

  // Excluir tag
  async delete(id: number): Promise<void> {
    await apiRequest.delete(`${this.baseUrl}/${id}`);
  }
}

export const tagService = new TagService();
export default tagService;
